import React from 'react';
import { ThemeContext } from '../../../module/ThemeManager';
import { Container, Box, Grid, Typography } from '@mui/material';
import { theme } from '../../../constants/theme';
import { CompanyHeader } from '../../CompanyComponents/CompanyHeader';
import { CompanyOverview } from '../../CompanyComponents/CompanyOverview';
import { CompanyTabs } from '../../CompanyComponents/CompanyTabs';
import { CompanyContainerSkeleton } from './CompanyContainerSkeleton';
import { ICompanyDetails } from '../../../redux/company/types';
import { useThemeContext } from '../../../hook/useThemeManager';
import { FONT_ENUM } from '../../../types/global/fonts.types';
import { CompanySidebar } from '../../CompanyComponents';

interface ICompanyContainer {
    companyDetails?: ICompanyDetails;
    loading?: boolean;
    onEditClick?: () => void;
}

const CompanyContainer: React.FC<ICompanyContainer> = ({ companyDetails, loading = false, onEditClick }) => {
    const { themeStyle } = useThemeContext();
    if (loading) {
        return <CompanyContainerSkeleton />;
    }

    if (!loading && !companyDetails?.company) {
        return (
            <Container
                maxWidth={false}
                sx={{
                    display: 'flex',
                    width: '100vw',
                    height: '60vh',
                    justifyContent: 'center',
                    alignItems: 'center',
                }}>
                <Typography sx={{ color: theme[themeStyle].tag_white, fontFamily: FONT_ENUM.MAIN_MEDIUM }}>
                    Company not found
                </Typography>
                ;
            </Container>
        );
    }

    return (
        <ThemeContext.Consumer>
            {({ themeStyle }) => {
                return (
                    <Container
                        disableGutters
                        maxWidth={false}
                        style={{
                            height: 'auto',
                            justifyContent: 'flex-start',
                            display: 'flex',
                            alignItems: 'center',
                            flexDirection: 'column',
                        }}
                        sx={{
                            width: '100%',
                            marginLeft: { xs: '0px', sm: '65px' },
                            paddingLeft: { xs: '16px', sm: '40px', xl: '100px' },
                            paddingRight: { xs: '16px', sm: '40px' },
                            paddingTop: { xs: '20px', sm: '40px' },
                            overflowX: 'hidden',
                            minHeight: '70vh',
                            backgroundColor: theme[themeStyle].pure_black,
                        }}>
                        <Box sx={{ width: '100%' }}>
                            <CompanyHeader companyDetails={companyDetails} onEditClick={onEditClick} />
                            <Grid container spacing={3} sx={{ my: 2 }}>
                                <Grid item xs={12} lg={8}>
                                    <CompanyOverview companyDetails={companyDetails} />
                                    <CompanyTabs companyDetails={companyDetails} />
                                </Grid>
                                <Grid item xs={12} lg={4}>
                                    <CompanySidebar companyDetails={companyDetails} />
                                </Grid>
                            </Grid>
                        </Box>
                    </Container>
                );
            }}
        </ThemeContext.Consumer>
    );
};

export { CompanyContainer };
